import { AnimatePresence } from "framer-motion";

// Extend the AnimatePresence type to include the mode prop
export interface AnimatePresenceProps {
  children: React.ReactNode;
  mode?: "sync" | "wait" | "popLayout";
  initial?: boolean;
  onExitComplete?: () => void;
  custom?: any;
}

// Create a properly typed AnimatePresence component
export const AnimatePresenceWithProps =
  AnimatePresence as React.FC<AnimatePresenceProps>;
